import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { GrantComplimentarySubscriptionResponse } from './types';

type GrantMemberComplimentarySubscriptionParams = {
  memberId: string;
};

export async function grantMemberComplimentarySubscription({ memberId }: GrantMemberComplimentarySubscriptionParams) {
  const url = `/web/studio/users/${memberId}/products-subscriptions/complimentary`;

  const response = await api.executePostRequest<ObjectResponse<GrantComplimentarySubscriptionResponse>>(url, {});

  return response.data;
}
